import { Switch as MuiSwitch, styled, type SwitchProps } from "@mui/material";
import colors from "../theme/Colours";

type CustomSwitchProps = {
  onLabel?: string;
  offLabel?: string;
  trackHeight?: number;
  thumbSize?: number;
  trackWidth?: number;
};

export const Switch = styled((props: SwitchProps & CustomSwitchProps) => (
  <MuiSwitch {...props} />
))<CustomSwitchProps>(({
  onLabel = "ON",
  offLabel = "OFF",
  trackHeight = 40,
  thumbSize = 30,
  trackWidth = 100,
}) => {
  const sideMargin = 8;
  const translateX = trackWidth - thumbSize - sideMargin * 2;
  const vertMargin = Math.max(0, (trackHeight - thumbSize) / 2);

  return {
    overflow: "visible",
    padding: "0",
    height: `${trackHeight}px`,
    width: `${trackWidth}px`,
    "& .MuiSwitch-track": {
      borderRadius: "100px",
      display: "flex",
      alignItems: "center",
      backgroundColor: colors.greyTypography,
      opacity: 1,

      position: "relative",
      "&::before, &::after": {
        position: "absolute",
        fontFamily: "Segoe UI",
        fontSize: `${Math.max(12, Math.round(trackHeight * 0.45))}px`,
        fontWeight: 600,
      },
      "&::before": {
        content: `"${onLabel}"`,
        color: colors.background2,
        left: "10px",
        opacity: 0,
      },
      "&::after": {
        content: `"${offLabel}"`,
        color: colors.background2,
        right: "10px",
        opacity: 1,
      },
    },
    "& .MuiSwitch-thumb": {
      width: `${thumbSize}px`,
      height: `${thumbSize}px`,
      background: colors.background2,
      padding: 0,
      margin: `${vertMargin}px ${sideMargin}px`,
      position: "relative",
    },

    "& .MuiSwitch-switchBase": {
      padding: "0px ",
      "&.Mui-checked": {
        transform: `translateX(${translateX}px)`,
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: colors.primaryButtonOrange,
          "&::before": { opacity: 1 },
          "&::after": { opacity: 0 },
        },
      },
    },
  };
});
